import {textHandle} from 'presentation/utils/textHandle';
import {useQueryParams} from 'presentation/pages';
import {getServiceInfo} from 'presentation/modules/guide/shared/utils/getServiceInfo';

export function useProvidersResults() {
	const {SEARCH_PARAMS} = useQueryParams();
	const {serviceType, specialtyName} = SEARCH_PARAMS;
	const {label} = getServiceInfo(serviceType);

	const title = specialtyName
		? `${label} de ${textHandle(specialtyName).capitalizeFirstLetter()}`
		: label;

	return {
		title,
	};
}
